module.exports = __webpack_public_path__ + "img/ppc.a05ca163.jpg";